module.exports = __webpack_public_path__ + "frontend/images/pattern/black.jpg?b8270cd233d9a153560e9dcdb6588dcd";